"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationPaginationLoaderProvider = exports.usePaginationLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var PaginationLoader = /*#__PURE__*/_react["default"].createContext(false);
var PaginationPaginationLoaderProvider = function PaginationPaginationLoaderProvider(props) {
  var _useState = (0, _react.useState)(false),
    isLoading = _useState[0],
    setLoading = _useState[1];
  var setPaginationLoadingState = function setPaginationLoadingState(state) {
    setLoading(state);
  };
  return __jsx(PaginationLoader.Provider, {
    value: {
      isLoading: isLoading,
      setPaginationLoadingState: setPaginationLoadingState
    }
  }, props.children);
};
exports.PaginationPaginationLoaderProvider = PaginationPaginationLoaderProvider;
var usePaginationLoader = function usePaginationLoader() {
  return (0, _react.useContext)(PaginationLoader);
};
exports.usePaginationLoader = usePaginationLoader;